import React from "react";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";

type AppProps = {
  tableHeaders: TableHeadersType[];
  data: any;
};

const EinvoiceTableData = ({ tableHeaders, data }: AppProps) => {
  
  const renderTableData=()=>{
   let finalData=  data?.map((dataItem: any, index: number) => {
       
      return (<tr key={dataItem?.job_id}>
          {tableHeaders?.length &&
            tableHeaders?.map((header: TableHeadersType | any) => {
              if (header.value === "item_serial_number") {
                return <td>{dataItem?.item_serial_number}</td>
              } else if (header.value === "product_description") {
                return <td>{dataItem?.product_description}</td>
              } else if (header.value === "unit") {
                return <td>{dataItem?.unit}</td>
              } else if (header.value === "quantity") {
                return <td>{dataItem?.quantity}</td>
              } else if (header.value === "hsn_code") {
                return <td>{dataItem?.hsn_code}</td>
              } else if (header.value === "discount") {
                return <td>{dataItem?.discount}</td>
              } else if (header.value === "unit_price") {
                return <td>{dataItem?.unit_price}</td>
              } else if (header.value === "total_amount") {
                return <td>{dataItem?.total_amount}</td>
              } else if (header.value === "assessable_value") {
                return <td>{dataItem?.assessable_value}</td>
              } else if (header.value === "quantity") {
                return <td>{dataItem?.quantity}</td>
              } else if (header.value === "hsn_code") {
                return <td>{dataItem?.hsn_code}</td>
              } else if (header.value === "discount") {
                return <td>{dataItem?.discount}</td>
              } else if (header.value === "unit_price") {
                return <td>{dataItem?.unit_price}</td>
              } else if (header.value === "total_amount") {
                return <td>{dataItem?.total_amount}</td>
              } else if (header.value === "assessable_value") {
                return <td>{dataItem?.assessable_value}</td>
              } else if (header.value === "gst_rate") {
                return <td>{dataItem?.gst_rate}</td>
              } else if (header.value === "igst_amount") {
                return <td>{dataItem?.igst_amount}</td>
              } else if (header.value === "sgst_amount") {
                return <td>{dataItem?.sgst_amount}</td>
              } else if (header.value === "cgst_amount") {
                return <td>{dataItem?.cgst_amount}</td>
              } else if (header.value === "total_item_value") {
                return <td>{dataItem?.total_item_value}</td>
              } else if (header.value === "is_service") {
                return <td>{dataItem?.is_service}</td>
              } else {
                return "";
              }
            })}
        </tr>
      );
    });

    return finalData;
  }


  return(
    <>
    {renderTableData()}
    </>
  )
};

export default EinvoiceTableData;
